/**
 * SEO Sprint 2 — Destination page: Sint Maarten (/shipping-to-sint-maarten).
 * CMS-driven via `destination_page_settings` slug=sint-maarten.
 */
import React from "react";
import DestinationPage from "../components/DestinationPage";

const SINT_MAARTEN_FALLBACK = {
  display_name: "Sint Maarten",
  country_code: "SX",
  url_path: "/shipping-to-sint-maarten",
  page_banner: {
    eyebrow: "Bestemming: Sint Maarten",
    title: "Verzenden naar",
    highlight: "Sint Maarten",
    subtitle:
      "Pakketten, verhuiszendingen of zakelijke cargo van Nederland naar Sint Maarten. Eén partner voor pickup, documenten en levering op het eiland.",
    badges: [
      { icon: "ship",    label: "Zee- en luchtvracht" },
      { icon: "package", label: "Pakketten t/m cargo" },
      { icon: "support", label: "Persoonlijke begeleiding" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Over verzendingen naar Sint Maarten",
    title: "Hoe wij uw zending naar Sint Maarten regelen",
    body:
      "Verzending naar Sint Maarten (Nederlandse zijde) regelt u via onze zee- en luchtvrachtroutes. Wij ondersteunen particulieren, verhuizers en bedrijven met pickup vanuit Nederland, complete documentatie en lokale aflevering. Per zending kijken wij of zeevracht of luchtvracht voor u voordeliger en praktischer is.\n\nBeschikbaarheid, tarieven en procedures kunnen per bestemming en type zending verschillen. Vraag actuele routebeschikbaarheid aan — onze medewerkers helpen u graag met de juiste verzendoptie.",
  },
  service_blocks: { items: [] },
  faq: { items: [] },
  cta_band: {
    title: "Klaar om naar Sint Maarten te verzenden?",
    description:
      "Vraag een vrijblijvende offerte aan met uw zendingdetails — wij adviseren binnen 1 werkdag de juiste route, kosten en documenten.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  seo: {
    title: "Pakket naar Sint Maarten sturen | Zee- en luchtvracht | 5999Cargo",
    description:
      "Verzend pakketten, verhuisgoederen of cargo van Nederland naar Sint Maarten. Zee- of luchtvracht via 5999Cargo Group Europe.",
    keywords:
      "pakket naar Sint Maarten sturen, zeevracht Sint Maarten, luchtvracht Sint Maarten, vracht naar Sint Maarten, shipping to Sint Maarten from Netherlands",
  },
};

export default function ShippingToSintMaartenPage() {
  return <DestinationPage slug="sint-maarten" fallback={SINT_MAARTEN_FALLBACK} />;
}
